<div class="campaign-container">
  <ces-asset-breadcrumb [trail]="nav.breadcrumbTrail()" />

  @if (pageStore.currentCampaign(); as campaign) {
    <ces-route-title [title]="pageStore.currentCampaignTitle()">
      @if (campaignMenuItems().length > 0) {
        <ces-menu-button-secondary
          [hasPermission]="{ method: 'putCampaignDetailResource', assetId: campaign.assetId }"
          icon="more_vert"
          [items]="campaignMenuItems()" />
      }
    </ces-route-title>
    <div class="flex items-center gap-(--gap-tight) -mt-(--space-2) mb-(--space-2)">
      <p-tag
        rounded="true"
        [severity]="pageStore.getStatusSeverity(campaign.status)"
        [value]="pageStore.getStatusLabel(campaign.status)"
        styleClass="whitespace-nowrap text-xs" />
      <ces-campaign-tags
        [hasPendingConflicts]="campaign.hasPendingConflicts ?? false"
        [hasImportedData]="campaign.hasImportedData ?? false"
        (resolveConflicts)="onResolveConflicts()" />
    </div>
  }

  <p-tabs [value]="activeIndex()">
    <p-tablist>
      <p-tab [value]="0" (click)="onTabChange(0)"> {{ 'entities.campaign.tabs.general' | transloco }} </p-tab>
      <p-tab [value]="1" (click)="onTabChange(1)">
        {{ 'entities.campaign.tabs.measures' | transloco }}
        @if (hasUnsavedMeasuresChanges()) {
          <ces-status-dot />
        }
      </p-tab>
      <p-tab [value]="2" (click)="onTabChange(2)">
        {{ 'entities.campaign.tabs.auscultation' | transloco }}
        @if (hasUnsavedAuscultationChanges()) {
          <ces-status-dot />
        }
      </p-tab>
      <p-tab [value]="3" (click)="onTabChange(3)"> {{ 'entities.campaign.tabs.history' | transloco }} </p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel [value]="0">
        @if (activeIndex() === 0) {
          <router-outlet />
        }
      </p-tabpanel>
      <p-tabpanel [value]="1">
        @if (activeIndex() === 1) {
          <router-outlet />
        }
      </p-tabpanel>
      <p-tabpanel [value]="2">
        @if (activeIndex() === 2) {
          <router-outlet />
        }
      </p-tabpanel>
      <p-tabpanel [value]="3">
        @if (activeIndex() === 3) {
          <router-outlet />
        }
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
